import { Clear } from "@mui/icons-material";
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Stack,
  TextField,
} from "@mui/material";
import useFilterGroup from "features/PanelManagement/hooks/useFilterGroup";
import getExactKeywordFieldError from "features/PanelManagement/utils/getExactKeywordFieldError";
import TEST_ID from "enums/TEST_ID";
import { getDataTestProp } from "utils/cypressTesting";
import KeywordFilter_Tooltip from "../components/KeywordFilter_Tooltip";

export const KEYWORD_FILTER = "Keyword Filter";

const FULL_TEXT_PLACEHOLDER = "Find people by keyword";
const EXACT_PLACEHOLDER = "e.g. dog and -cat";

export default function KeywordFilter() {
  const {
    keywordSearch = "",
    exactKeywordSearch,
    setFilterGroup,
  } = useFilterGroup(KEYWORD_FILTER);
  const isExactSearch = Boolean(exactKeywordSearch);
  const fieldError = getExactKeywordFieldError(keywordSearch, isExactSearch);

  return (
    <Stack spacing={0.5} sx={{ width: "100%", flex: 1 }}>
      <TextField
        {...getDataTestProp(TEST_ID.hydra.keywordInput)}
        onClick={(e) => e.stopPropagation()}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterGroup({ keywordSearch: e.target.value })
        }
        placeholder={isExactSearch ? EXACT_PLACEHOLDER : FULL_TEXT_PLACEHOLDER}
        value={keywordSearch}
        error={Boolean(fieldError)}
        helperText={fieldError}
        slotProps={{
          input: {
            startAdornment: (
              <KeywordFilter_Tooltip
                mode={isExactSearch ? "exact" : "fullText"}
                onExampleSelect={(example) =>
                  setFilterGroup({ keywordSearch: example })
                }
              />
            ),
            endAdornment: (
              <IconButton
                onClick={() => setFilterGroup({ keywordSearch: "" })}
                edge="end"
                sx={{
                  visibility: keywordSearch.length > 0 ? "visible" : "hidden",
                }}
              >
                <Clear />
              </IconButton>
            ),
          },
        }}
      />
      <FormControlLabel
        sx={{ ml: 0 }}
        control={
          <Checkbox
            size="small"
            checked={isExactSearch}
            onChange={(_, checked) =>
              setFilterGroup({ exactKeywordSearch: checked })
            }
          />
        }
        label="Exact string search"
      />
    </Stack>
  );
}
